/**
 * Дополняет число до двух разрядов лидирующим нулём.
 */
const pad2 = (n: number): string => String(n).padStart(2, '0');

/**
 * Форматирует секунды в `мм:сс`. Возвращает `'—'` для null/undefined.
 * Минуты могут превышать 99 — для очень длинных значений предпочтительнее `formatHHMMSS`.
 */
export const formatMMSS = (seconds: number | null | undefined): string => {
  if (seconds === null || seconds === undefined || !Number.isFinite(seconds)) return '—';
  const total = Math.max(0, Math.round(seconds));
  const minutes = Math.floor(total / 60);
  const secs = total % 60;
  return `${pad2(minutes)}:${pad2(secs)}`;
};

/**
 * Форматирует секунды в `чч:мм:сс`. Возвращает `'—'` для null/undefined.
 */
export const formatHHMMSS = (seconds: number | null | undefined): string => {
  if (seconds === null || seconds === undefined || !Number.isFinite(seconds)) return '—';
  const total = Math.max(0, Math.round(seconds));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secs = total % 60;
  return `${pad2(hours)}:${pad2(minutes)}:${pad2(secs)}`;
};

/**
 * Форматирует целое число с разделителями тысяч (текущая локаль).
 */
export const formatInt = (value: number | null | undefined): string => {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  return Math.round(value).toLocaleString();
};

/**
 * Конвертирует период оси X в формат `дд.мм.гггг`.
 *
 * Применяется на оси X трендов «Дашборда КЦ» при `groupBy = day`,
 * когда `period` приходит как ISO-дата `YYYY-MM-DD`. Для значений в другом
 * формате (например, week/month) возвращает исходную строку без изменений.
 */
export const formatDayPeriod = (period: string): string => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(period);
  if (!match) return period;
  const [, year, month, day] = match;
  return `${day}.${month}.${year}`;
};
